import React from "react";
import summaryIcon from "../assets/summary.png";
import SummaryItem from "./SummaryItem";
import { formatarValor } from "./OrderTable";

const DetailsOrderLoad = ({
  title,
  id,
  index,
  custo,
  transporte,
  impostos,
  total,
}) => {
  return (
    <div className="bg-[#F9F9F9] my-2 p-2 xl:p-4 flex cursor-pointer">
      <div className="w-full text-[#2F2E41] opacity-80 flex">
        <div className="py-2 text-[#2F2E41] opacity-80 flex flex-grow">
          <div className="flex justify-center items-center 2xl:px-4">
            <img
              className="md:w-[30px] lg:w-[40px] xl:w-[50px]"
              src={summaryIcon}
              alt=""
            />
          </div>
          <div className="2xl:w-[342px] 2xl:ml-4  flex flex-col justify-center md:ml-2">
            <p className="md:text-xs lg:text-base xl:text-xl 2xl:text-2xl">
              {title}
            </p>
            <p className="md:text-base lg:text-base xl:text-xl 2xl:text-2xl font-bold">
              {`C00${index}-${new Date().getFullYear()}`}
            </p>
          </div>
        </div>

        <div className="text-center flex justify-between items-center flex-grow ">
          <SummaryItem label="Custo" value={formatarValor(custo, "USD")} />
          <SummaryItem
            label="Transporte"
            value={formatarValor(transporte, "USD")}
          />
          <SummaryItem
            label="Impostos"
            value={formatarValor(impostos, "USD")}
          />
          <SummaryItem label="Total" value={formatarValor(total, "USD")} />
        </div>
      </div>
    </div>
  );
};

export default DetailsOrderLoad;
